<template>
    <transition name="customer-service-fade">
        <div v-if="value" class="customer-service-mask" @click.self="close">
            <section
                class="customer-service-panel"
                :style="panelStyle"
                role="dialog"
                aria-modal="true"
                aria-label="在线客服"
            >
                <header>
                    <span class="panel-title">
                        <img
                            src="@/assets/images/whiteCard/logo.png"
                            alt=""
                        />
                        在线客服
                    </span>
                    <button
                        type="button"
                        aria-label="关闭在线客服"
                        title="关闭"
                        @click="close"
                    >
                        <van-icon name="cross" />
                    </button>
                </header>

                <div class="service-row">
                    <span class="service-icon time"
                        ><van-icon name="clock-o"
                    /></span>
                    <div>
                        <small>服务时间</small><strong>8:00 - 21:00</strong>
                    </div>
                </div>
                <div class="service-row">
                    <span class="service-icon phone"
                        ><van-icon name="phone-o"
                    /></span>
                    <div>
                        <small>客服热线</small
                        ><a href="tel:10020">10020</a>
                    </div>
                </div>
                <div class="service-row">
                    <span class="service-icon wechat"
                        ><van-icon name="chat-o"
                    /></span>
                    <div>
                        <small>微信客服</small>
                        <a
                            class="online-service-link"
                            href="https://lmhy.scenifyai.com/customer-service.html"
                        >
                            <span>连接在线客服</span><van-icon name="arrow" />
                        </a>
                    </div>
                </div>
            </section>
        </div>
    </transition>
</template>

<script>
export default {
    name: "WhiteCardCustomerService",
    props: {
        value: {
            type: Boolean,
            default: false,
        },
        bottomOffset: {
            type: Number,
            default: 96,
        },
    },
    computed: {
        panelStyle() {
            return {
                "--customer-service-bottom": `${this.bottomOffset}px`,
            }
        },
    },
    methods: {
        close() {
            this.$emit("input", false)
        },
    },
}
</script>

<style scoped lang="scss">
.customer-service-mask,
.customer-service-mask * {
    box-sizing: border-box;
}

.customer-service-mask {
    position: fixed;
    inset: 0;
    z-index: 1000;
}

.customer-service-panel {
    width: 206px;
    padding: 10px 12px 12px;
    position: absolute;
    right: max(14px, calc((100vw - 480px) / 2 + 14px));
    bottom: calc(env(safe-area-inset-bottom) + var(--customer-service-bottom));
    color: #2a2336;
    background: #fff;
    border: 1px solid #ffc9bc;
    border-radius: 14px;
    box-shadow: 0 12px 30px rgba(140, 45, 25, 0.2);
    font-family: "PingFang SC", "Microsoft YaHei", sans-serif;
}

.customer-service-panel header {
    height: 26px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    color: #c62828;
    font-size: 14px;
    font-weight: 800;
}

.panel-title {
    display: inline-flex;
    align-items: center;
    gap: 5px;
}

.panel-title img {
    width: 18px;
    height: 18px;
    border-radius: 50%;
}

.customer-service-panel header button {
    width: 22px;
    height: 22px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    color: #a89fae;
    background: #f6f3f1;
    border-radius: 50%;
    font-size: 14px;
}

.service-row {
    min-height: 40px;
    display: flex;
    align-items: center;
    gap: 9px;
}

.service-icon {
    width: 28px;
    height: 28px;
    flex: 0 0 28px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    color: #f4511e;
    background: #fff0ec;
    border-radius: 9px;
    font-size: 15px;
}

.service-icon.phone {
    color: #ef3e2f;
    background: #fff0ec;
}

.service-icon.wechat {
    color: #c62828;
    background: #fff0ec;
}

.service-row div {
    min-width: 0;
    display: flex;
    flex-direction: column;
}

.service-row small {
    color: #9b93a0;
    font-size: 10px;
    line-height: 13px;
}

.service-row strong,
.service-row a {
    color: #3d3546;
    font-size: 13px;
    line-height: 18px;
    font-weight: 700;
    text-decoration: none;
}

.online-service-link {
    display: inline-flex;
    align-items: center;
    gap: 3px;
    color: #f4511e !important;
}

.online-service-link .van-icon {
    font-size: 11px;
}

.customer-service-fade-enter-active,
.customer-service-fade-leave-active {
    transition: opacity 0.16s ease;
}

.customer-service-fade-enter-active .customer-service-panel,
.customer-service-fade-leave-active .customer-service-panel {
    transition: transform 0.16s ease, opacity 0.16s ease;
}

.customer-service-fade-enter,
.customer-service-fade-leave-to {
    opacity: 0;
}

.customer-service-fade-enter .customer-service-panel,
.customer-service-fade-leave-to .customer-service-panel {
    opacity: 0;
    transform: translateY(6px);
}
</style>
